'use client'

import { createContext, useContext } from 'react'

import { ShowConfirmModalParams } from 'Types/App'

import { UserFragment } from 'GraphQL/Main/TypedDocuments'

type AppContextValue = {
  me?: UserFragment
  showConfirmModal?: (params?: ShowConfirmModalParams) => Promise<boolean>
  meLoading: boolean
}

const AppContext = createContext<AppContextValue>({ meLoading: false })

function useAppContext() {
  return useContext(AppContext)
}

export type { AppContextValue }
export { AppContext, useAppContext }
